import React from 'react';
import PropTypes from 'prop-types';
import {get} from '../Storage';
import axios from 'axios';
import CircularProgress from 'material-ui/CircularProgress';
import {DateTool} from 'mgToolsKit';
import MemobetLoader from '../Widget/MemobetLoader';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TableMemobetListComponent';

var styles = AppSettings.styles;

class MemobetList extends React.Component {
    constructor(props, context) {
        super(props);
        this.state = {
            error: false,
            errorMessage: "",
            data: [],
            showLoading: true,
            opened:false,
        }
        this.getData = this.getData.bind(this);
        this.loadMemobet = this.loadMemobet.bind(this);
    }

    componentDidMount() {        
        this.getData();
    }

    getData(event) {
        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                showLoading: true,
                opened: false
            });
            return;
        }        

        this.setState({
            showLoading: true,
            opened:true
        });

        var url = AppSettings['env'].urlUserBoxGetListMemobet;
        axios.get(url)
            .then(({data, status, statusText}) => {
                this.setState({
                    error: false,
                    errorMessage: "",
                    data: data,
                    showLoading: false,
                });
            })

            .catch(function(error) {
                this.setState({
                    error: true,
                    errorMessage: "",
                    data: [],
                    showLoading: false,
                    opened: true
                });
            });
    }

    shareMemobet(memobetCode){
        if(typeof _betSlip !=  "undefined"){
            _betSlip.loadSavedBet(memobetCode, true);
        }
        else{
            location.href = "/scommesse-sportive?cart="+memobetCode+ "&cartModal=on"+ (AppSettings.device == "desktop"?"":"&mobile=true");
        }
    }
    hideMemobet(memobetCode){
        if(confirm("Nascondere la memobet?")){
            //this.getData();
        }
    }
    
    loadMemobet(memobetCode){
        if(typeof _betSlip !=  "undefined"){
            _betSlip.loadSavedBet(memobetCode, false);
            // Chiudo la userbox
            this.context.handleTab(false);
        }
        else{
            location.href = "/scommesse-sportive?cart=" + memobetCode + (AppSettings.device == "desktop"?"":"&mobile=true");
        }
    }

    renderData(){
        if(this.state.showLoading){
            return (
                 <CircularProgress style={styles.loadingIcon}/>
            );
        }

        var data;

        if (this.state.data.length > 0) {
            data = this.state.data.map(function (memobet, i) {
                var key = "memobet-"+memobet.Code;
                var className = "userBoxMemobet";
               
                var type;
                if(memobet.cart.IsSystem){
                    type = "Sistema";
                }
                else{
                    type = "Standard";
                }
                var expire = new DateTool(memobet.ExpiresOn);
                var note = "";
                if(memobet.cart.Note != null && memobet.cart.Note != ""){
                    note = <li className="userBoxMemobet--note">{memobet.cart.Note}</li>;
                }
                return (
                    <ul key={key} className={className} title="Visualizza Memobet">
                        <li className="userBoxTicket--heading">
                            <a className="userBoxMemobet--code" href="#"  onClick={this.loadMemobet.bind(this, memobet.Code)}>{memobet.Code}</a>
                            <h3 className="userBoxMemobet--scadenza"><span className='text-label'>Scade il {expire.toString()}</span></h3>
                            {/*
                            <a className="btn-hide-memobet" title="Nascondi Memobet"  onClick={this.hideMemobet.bind(this, memobet.Code)} href="#">
                                <i className="fa fa-eye-slash" aria-hidden="true"></i>
                            </a>
                            */}
                            <a className="btn-share-memobet" title="Condividi la Memobet"  onClick={this.shareMemobet.bind(this, memobet.Code)} href="#">
                                <i className="fa-mg fa-mg-share" aria-hidden="true"></i>
                            </a>

                        </li>
                        <li className="userBoxMemobet--dettagli" onClick={this.loadMemobet.bind(this, memobet.Code)}>
                           <ul>
                                <li><span className='mg-ticket-type-label'>Eventi</span><span>{memobet.cart.Outcomes.length}</span></li>
                                <li><span className='mg-ticket-type-label'>Tipo</span><span>{type}</span></li>
                                <li><span className='mg-ticket-type-label'>Giocata</span><span>&euro; {memobet.cart.Amount.toFixed(2)}</span></li>
                                <li><span className='mg-ticket-type-label'>Vincita</span><span>&euro; {memobet.cart.Winning.toFixed(2)}</span></li>
                            </ul>
                         </li>
                         {note}  
                    </ul>
                ); 
            }.bind(this));
        }
        // else {
        //     data = <ul className="userBoxMemobet userBoxMemobet--noresult">
        //            <li>Non hai Memobet salvate</li>
        //            </ul>;
        // }

        return (
            <div className="mg-user-widget">

                <MemobetLoader />   
                <div className="userBoxBetTicketContainer">
                    {data}
                </div>       
                {/* 
                <table className="userBoxTable userBoxMemobet">
                    <thead>
                    <tr className="userBoxMemobet--head">
                        <th>MemoBet</th>
                        <th>Dettagli</th>
                        <th>Condividi</th>
                    </tr>
                    </thead>
                    <tbody>
                       {data}
                    </tbody>
                </table> 
                */}   
            </div>
        );
    }
    render() {
        return this.renderData();
    }
}
MemobetList.displayName = componentName;

// PropTypes validation
MemobetList.propTypes = {};

// default props
MemobetList.defaultProps = {};

MemobetList.contextTypes = {
    handleTab: PropTypes.func
}

export default MemobetList;